import React from 'react'
import { useSelector } from 'react-redux';
import { useDraggableSheet } from '../../../helpers/hooks';
import Icon from '../Icon/Icon';
import './CreateModal.scss';
import { useNavigate } from 'react-router-dom';
import { useSoftwall } from '../../containers/SoftWall/SoftWall';
import { userNeedsEmailVerificationOrPasswordSetup } from '../../constants/signupFlow';

const CreateModal = ({ onClose }) => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth?.user);
    const session = useSelector((state) => state.auth?.session);
    const sw = useSoftwall();

    const {
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    return (
        <div
            className="create-section"
            {...overlayHandlers}
        >
            <div
                className={`sheet`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >

                    <div className='d-flex align-items-center gap-16 py-24 border-bottom'
                        onClick={() => {
                            onClose();
                            if (userNeedsEmailVerificationOrPasswordSetup(user, session)) {
                                sw?.openModal?.('verify-email');
                                return;
                            }
                            navigate('/creations/add');
                        }}>
                        <Icon alias={'magic_v2'} width={28} height={28} color='#FF3232' />
                        <p className='my-0 fs-sm2 fg-black fw-medium-bold'>Publish a Creation</p>
                    </div>
                    <div className='d-flex align-items-center gap-16 py-24'
                        onClick={() => {
                            onClose();
                            if (userNeedsEmailVerificationOrPasswordSetup(user, session)) {
                                sw?.openModal?.('verify-email');
                                return;
                            }
                            navigate('/news/add');
                        }}>
                        <Icon alias={'news_flash'} width={28} height={28} color='#FF3232' />
                        <p className='my-0 fs-sm2 fg-black fw-medium-bold' >Write a News</p>
                    </div>
                </div>
        </div>
    )
}

export default CreateModal